import {
    ALL_IN_COST,
    BASE_POT_VALUE,
    CARD_NAMES,
    CARD_VALUE_MULTIPLIER,
    CARD_VALUES,
    CARDS,
    FLOP_COST,
    HOLE_COST,
    RIVER_COST,
    SPY_OPPONENT_COST,
    TURN_COST,
} from '../../simulations/constants';

export const cards: GameCardsSetup = {
    allInCost: ALL_IN_COST,
    basePotValue: BASE_POT_VALUE,
    communityCost: FLOP_COST + TURN_COST + RIVER_COST,
    deck: CARDS as GameCardType[],
    flopCost: FLOP_COST,
    flopRemainingCosts: FLOP_COST + TURN_COST + RIVER_COST,
    holeCost: HOLE_COST,
    holeRemainingCosts: HOLE_COST + FLOP_COST + TURN_COST + RIVER_COST,
    largeBudget: ALL_IN_COST * 10,
    names: CARD_NAMES,
    riverCost: RIVER_COST,
    riverRemainingCosts: RIVER_COST,
    smallBudget: ALL_IN_COST * 2,
    spyOpponentCost: SPY_OPPONENT_COST,
    turnCost: TURN_COST,
    turnRemainingCosts: TURN_COST + RIVER_COST,
    valueMultiplier: CARD_VALUE_MULTIPLIER,
    values: CARD_VALUES,
};
